import NavigationModel from '../../../components/CustomNavigation/NavigationModel';

const TpVerificationNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const redirectUrl = `${phpNavigationUrl}/tutor/payment_verification/${currentYear}/${currentMonth}/${userId}`;
  return <NavigationModel redirectUrl={redirectUrl} title="TP Verification" navigationTo={'Old Portal'} />;
};

export default TpVerificationNavigation;
